<ion-app fxLayout="row">
  <app-main-layout></app-main-layout>
</ion-app>